document.addEventListener("DOMContentLoaded", function () {
  let currentMin = 0;
  let currentMax = Infinity;
  let allFetchedProducts = [];
  let filteredProducts = [];   // products after price filter
  let filterActive = false;
  let originalGridHTML = null;
  let isFetching = false;
  let globalMin = 0;
  let globalMax = 60000;
  let cardCache = {};
  let currentFilterPage = 1;
  const ITEMS_PER_PAGE = 16;

  // ─── Intercept Boost's own API call to capture exact params ───────────────
  let _capturedParams = null;

  (function interceptBoost() {
    const origFetch = window.fetch;
    window.fetch = function (url, opts) {
      if (typeof url === 'string' && url.includes('mybcapps.com/bc-sf-filter/filter')) {
        try {
          const u = new URL(url);
          if (!_capturedParams) {
            _capturedParams = {};
            u.searchParams.forEach((v, k) => { _capturedParams[k] = v; });
          }
        } catch (e) {}
      }
      return origFetch.apply(this, arguments);
    };

    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (typeof url === 'string' && url.includes('mybcapps.com/bc-sf-filter/filter')) {
        try {
          const u = new URL(url);
          if (!_capturedParams) {
            _capturedParams = {};
            u.searchParams.forEach((v, k) => { _capturedParams[k] = v; });
          }
        } catch (e) {}
      }
      return origOpen.apply(this, arguments);
    };
  })();

  // ─── Document-level click capture (survives cloneNode) ────────────────────
  document.addEventListener('click', function (e) {
    const card = e.target.closest('[data-injected="true"]');
    if (!card) return;

    e.stopImmediatePropagation();
    e.stopPropagation();

    const anchor = e.target.closest('a[href]');
    if (anchor) {
      const href = anchor.getAttribute('href');
      if (href && href !== '#') {
        e.preventDefault();
        window.location.href = href;
      }
      return;
    }

    const btn = e.target.closest('button');
    if (btn) return;

    const productHref = card.getAttribute('data-product-url');
    if (productHref) {
      e.preventDefault();
      window.location.href = productHref;
    }
  }, true);

  // ─── Build API URL ────────────────────────────────────────────────────────
  function generateSid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function buildBoostApiUrl(pageNum) {
    if (_capturedParams) {
      const p = new URLSearchParams(_capturedParams);
      p.set('page', pageNum);
      p.set('t', Date.now());
      p.set('sid', generateSid());
      p.set('build_filter_tree', 'false');
      p.set('first_load', pageNum === 1 ? 'true' : 'false');
      if (pageNum > 1) {
        p.set('behavior', 'refresh');
        p.set('isMobile', 'false');
        p.set('isTabletPortraitMax', 'false');
      }
      return `https://services.mybcapps.com/bc-sf-filter/filter?${p.toString()}`;
    }

    const shop = window.Shopify?.shop || window.location.hostname;
    const scope = _getFallbackScope();
    const templateId = _getFallbackTemplateId();
    const p = new URLSearchParams({
      '_': 'pf', 't': Date.now(), 'sid': generateSid(),
      'shop': shop, 'page': pageNum, 'limit': 16,
      'sort': 'best-selling', 'locale': 'de',
      'event_type': 'init', 'pg': 'collection_page',
      'build_filter_tree': 'false',
      'collection_scope': scope,
      'money_format': 'CHF {{amount}}',
      'money_format_with_currency': 'CHF {{amount}}',
      'viewAs': 'grid--4', 'device': '',
      'first_load': pageNum === 1 ? 'true' : 'false',
      'productImageWidth': '350', 'productPerRow': '4',
      'templateId': templateId, 'simplifiedIntegration': 'true',
      'customer_id': '00000000-0000-0000-5000-000000000000',
      'insert_banners': 'false', 'return_all_currency_fields': 'false',
      'currency_rate': '1.0', 'currency': 'CHF', 'country': 'DE',
      'product_available': 'false', 'variant_available': 'false',
    });
    if (pageNum > 1) { p.set('behavior', 'refresh'); p.set('isMobile', 'false'); p.set('isTabletPortraitMax', 'false'); }
    return `https://services.mybcapps.com/bc-sf-filter/filter?${p.toString()}`;
  }

  function _getFallbackScope() {
    const boostWin = window.BCsfFilter || window.BoostSDAppConfig || window.BoostCommerce || {};
    if (boostWin.collectionId) return String(boostWin.collectionId);
    if (window.BoostSd?.collection?.id) return String(window.BoostSd.collection.id);
    let scope = '';
    document.querySelectorAll('script:not([src])').forEach(s => {
      const m = s.textContent.match(/collection_scope['":\s]+(\d+)/);
      if (m) scope = m[1];
    });
    return scope || '0';
  }

  function _getFallbackTemplateId() {
    let tid = '';
    document.querySelectorAll('script:not([src])').forEach(s => {
      const m = s.textContent.match(/templateId['":\s]+"([^"]+)"/);
      if (m) tid = m[1];
    });
    return tid;
  }

  function waitForCapture(callback, maxWait = 3000) {
    const start = Date.now();
    _tryTriggerBoost();
    const check = () => {
      if (_capturedParams) { callback(); }
      else if (Date.now() - start < maxWait) { setTimeout(check, 80); }
      else { callback(); }
    };
    check();
  }

  function _tryTriggerBoost() {
    try {
      if (window.BoostSd?.filterManager?.applyFilter) { window.BoostSd.filterManager.applyFilter({}); return; }
      if (window.BCsfFilter?.loadProducts) { window.BCsfFilter.loadProducts(1); return; }
      if (window.boostWidgetIntegration?.reRender) { window.boostWidgetIntegration.reRender(); return; }
    } catch (e) {}
  }

  // ─── Fetch single page ────────────────────────────────────────────────────
  async function fetchBoostPage(pageNum) {
    try {
      const res = await fetch(buildBoostApiUrl(pageNum), {
        headers: { 'Accept': 'application/json' },
        // Use keep-alive for connection reuse → faster concurrent fetches
        keepalive: true,
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      return { page: pageNum, products: data.products || [] };
    } catch (e) {
      console.error(`[PriceFilter] API page ${pageNum}:`, e);
      return { page: pageNum, products: [] };
    }
  }

  function getTotalPages() {
    const pl = document.querySelector('.boost-sd__product-list');
    if (pl?.dataset?.totalPage) return parseInt(pl.dataset.totalPage);
    let max = 1;
    document.querySelectorAll('.boost-sd__pagination-number').forEach(btn => {
      const n = parseInt(btn.textContent.trim());
      if (!isNaN(n) && n > max) max = n;
    });
    return max;
  }

  // ─── Build card ───────────────────────────────────────────────────────────
  function buildCard(product) {
    const price      = parseFloat(product.price_min) || 0;
    const isFree     = price === 0;
    const fmt        = 'CHF ' + price.toLocaleString('de-CH');
    const imgInfo    = product.images_info?.[0];
    const rawSrc     = (imgInfo?.src || '').split('&width=')[0];
    const imgW       = imgInfo?.width  || 800;
    const imgH       = imgInfo?.height || 600;
    const srcset     = rawSrc ? [200, 300, 400, 500, 700].map(w => `${rawSrc}&width=${w} ${w}w`).join(',\n') : '';
    const title      = product.title || '';
    const handle     = product.handle || '';
    const pid        = product.id || '';
    const vid        = product.variants?.[0]?.id || '';
    const productUrl = '/products/' + handle;

    const div = document.createElement('div');
    div.className = 'boost-sd__product-item boost-sd__product-item--no-border boost-sd__product-item-grid-view-layout';
    div.id = String(pid);
    div.setAttribute('data-product-id', String(pid));
    div.setAttribute('data-injected', 'true');
    div.setAttribute('data-product-url', productUrl);

    const priceBlock = isFree ? '' : `
      <div class="boost-sd__product-price">
        <div class="boost-sd__product-price-wrapper">
          <span class="boost-sd__visually-hidden">Regular price ${fmt}</span>
          <span aria-hidden="true" class="boost-sd__product-price-content boost-sd__product-price-content--row-reverse boost-sd__product-price-content--text-align-left">
            <span class="boost-sd__product-price--default"><span class="boost-sd__format-currency">${fmt}</span></span>
          </span>
        </div>
      </div>`;

    const ctaBlock = isFree
      ? `<a href="/pages/contact/" class="collection-request-quote">Angebot anfordern</a>`
      : (vid ? `<button aria-label="Add to cart" class="boost-sd__button boost-sd__button--select-option boost-sd__button--border boost-sd__button--hide-on-mobile boost-sd__button--rectangle boost-sd__button--left boost-sd__button--full-width" type="button" data-metadata='{"action":{"addToCart":{"productId":"${vid}","selling_plan":""}}}'>
          <span class="boost-sd__button-text boost-sd__cta-button-text">Add to cart</span></button>` : '');

    div.innerHTML = `
      <div class="boost-sd__product-item-grid-view-layout-image">
        <div class="boost-sd__product-link-image">
          <div style="position:relative">
            <div class="boost-sd__product-image-wrapper boost-sd__product-image-wrapper--zoom-in boost-sd__product-image-wrapper--natural" style="aspect-ratio:${imgW}/${imgH}">
              <a aria-label="${title}" class="boost-sd__product-link boost-sd__product-image" href="${productUrl}">
                <img class="boost-sd__product-image-img boost-sd__product-image-img--main"
                     loading="eager" decoding="async" alt="${title}"
                     src="${rawSrc}" srcset="${srcset}" width="auto" height="auto"
                     style="opacity:1!important;visibility:visible!important;display:block!important;"
                    onerror="this.onerror=null;this.removeAttribute('srcset');this.src='https://cdn.shopify.com/extensions/201f4d7b-8d39-43a4-82de-e6f412341695/0.0.0/assets/boost-pfs-no-image.jpg';">
              </a>
              <div class="boost-sd__product-image-row boost-sd__product-image-row--top">
                <div class="boost-sd__product-image-column boost-sd__product-image-column--in-top boost-sd__product-image-column--left"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="boost-sd__product-info-wrapper">
        <div class="boost-sd__product-info boost-sd__product-info--left">
          <a aria-label="${title}" class="boost-sd__product-link" href="${productUrl}">
            <div class="boost-sd__product-title">${title}</div>
          </a>
          ${priceBlock}
          ${ctaBlock}
        </div>
      </div>`;

    return div;
  }

  // ─── Loading overlay ──────────────────────────────────────────────────────
  function showLoading(show, msg, loaded, total) {
    let overlay = document.getElementById('cpf-loading-overlay');

    if (!show) {
      if (overlay) {
        overlay.style.opacity = '0';
        setTimeout(() => overlay?.remove(), 220);
      }
      return;
    }

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'cpf-loading-overlay';
      overlay.innerHTML = `
        <div id="cpf-loading-box">
          <div id="cpf-spinner"></div>
          <div id="cpf-loading-text">Wird geladen...</div>
          <div id="cpf-loading-bar-wrap"><div id="cpf-loading-bar"></div></div>
          <div id="cpf-loading-sub"></div>
        </div>`;
      document.body.appendChild(overlay);
      requestAnimationFrame(() => { overlay.style.opacity = '1'; });
    }

    const textEl = document.getElementById('cpf-loading-text');
    const subEl  = document.getElementById('cpf-loading-sub');
    const barEl  = document.getElementById('cpf-loading-bar');

    if (textEl) textEl.textContent = msg || 'Wird geladen...';

    if (loaded !== undefined && total) {
      const pct = Math.round((loaded / total) * 100);
      if (barEl) barEl.style.width = pct + '%';
      if (subEl) subEl.textContent = `${loaded} von ${total} Seiten geladen (${pct}%)`;
    } else {
      if (barEl) barEl.style.width = '5%';
      if (subEl) subEl.textContent = 'Verbinde mit Server...';
    }
  }

  // ─── Custom Pagination ────────────────────────────────────────────────────
  function buildCustomPagination(totalItems, currentPage) {
    const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
    if (totalPages <= 1) return null;

    const wrap = document.createElement('div');
    wrap.className = 'boost-sd__pagination boost-sd__pagination--center';
    wrap.id = 'cpf-custom-pagination';

    // Helper: make a page number button
    function makePageBtn(num, isActive) {
      const btn = document.createElement('button');
      btn.className = 'boost-sd__pagination-number boost-sd__pagination-number--square' +
                      (isActive ? ' boost-sd__pagination-number--active' : '');
      btn.setAttribute('aria-label', isActive ? `Current Page ${num}` : `Go to Page ${num}`);
      btn.textContent = num;
      if (!isActive) {
        btn.addEventListener('click', () => goToFilterPage(num));
      }
      return btn;
    }

    // Helper: make ellipsis
    function makeEllipsis() {
      const btn = document.createElement('button');
      btn.className = 'boost-sd__pagination-number boost-sd__pagination-number--disabled boost-sd__pagination-number--square';
      btn.setAttribute('aria-hidden', 'true');
      btn.textContent = '...';
      return btn;
    }

    // Helper: make prev/next button
    function makeNavBtn(direction, disabled) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', direction === 'prev' ? 'previous page' : 'next page');
      btn.className = `boost-sd__pagination-button boost-sd__pagination-button--square boost-sd__pagination-button--${direction === 'prev' ? 'prev' : 'next'}`;
      if (disabled) {
        btn.disabled = true;
        btn.style.opacity = '0.3';
        btn.style.pointerEvents = 'none';
      }
      const iconDir = direction === 'prev' ? 'left' : 'right';
      btn.innerHTML = `<span class="boost-sd__pagination-button-icon boost-sd__pagination-button-icon--${iconDir}">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 7 12" height="12" width="7">
          ${direction === 'prev'
            ? '<path d="M6.80474 0.528514C6.54439 0.268165 6.12228 0.268165 5.86193 0.528514L0.861929 5.52851C0.601579 5.78886 0.601579 6.21097 0.861929 6.47132L5.86193 11.4713C6.12228 11.7317 6.54439 11.7317 6.80474 11.4713C7.06509 11.211 7.06509 10.7889 6.80474 10.5285L2.27614 5.99992L6.80474 1.47132C7.06509 1.21097 7.06509 0.788864 6.80474 0.528514Z" clip-rule="evenodd" fill-rule="evenodd"></path>'
            : '<path d="M0.195262 0.528514C0.455612 0.268165 0.877722 0.268165 1.13807 0.528514L6.13807 5.52851C6.39842 5.78886 6.39842 6.21097 6.13807 6.47132L1.13807 11.4713C0.877722 11.7317 0.455612 11.7317 0.195262 11.4713C-0.0650874 11.211 -0.0650874 10.7889 0.195262 10.5285L4.72386 5.99992L0.195262 1.47132C-0.0650874 1.21097 -0.0650874 0.788864 0.195262 0.528514Z" clip-rule="evenodd" fill-rule="evenodd"></path>'
          }
        </svg>
      </span>`;
      if (!disabled) {
        btn.addEventListener('click', () => goToFilterPage(direction === 'prev' ? currentPage - 1 : currentPage + 1));
      }
      return btn;
    }

    // Build page number list with smart ellipsis (same logic as Boost)
    // Always show: first, last, current ±2, with ellipsis gaps
    function getPageNumbers() {
      const pages = [];
      const delta = 2;
      const range = [];
      for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
        range.push(i);
      }
      if (currentPage - delta > 2) range.unshift('...');
      if (currentPage + delta < totalPages - 1) range.push('...');
      range.unshift(1);
      if (totalPages > 1) range.push(totalPages);
      return range;
    }

    // Prev button
    wrap.appendChild(makeNavBtn('prev', currentPage === 1));

    // Page numbers
    getPageNumbers().forEach(p => {
      if (p === '...') {
        wrap.appendChild(makeEllipsis());
      } else {
        wrap.appendChild(makePageBtn(p, p === currentPage));
      }
    });

    // Next button
    wrap.appendChild(makeNavBtn('next', currentPage === totalPages));

    return wrap;
  }

  function goToFilterPage(page) {
    currentFilterPage = page;
    renderPage(filteredProducts, page);
    // Scroll to top of grid
    const grid = document.querySelector('.boost-sd__product-list, .boost-sd__product-grid');
    if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ─── Render a single page of filtered results ─────────────────────────────
  function renderPage(products, page) {
    const grid = document.querySelector('.boost-sd__product-list, .boost-sd__product-grid');
    if (!grid) return;

    const totalPages = Math.ceil(products.length / ITEMS_PER_PAGE);
    const start = (page - 1) * ITEMS_PER_PAGE;
    const pageProducts = products.slice(start, start + ITEMS_PER_PAGE);

    isRendering = true;
    observer.disconnect();
    grid.innerHTML = '';

    pageProducts.forEach(product => {
      const pid = String(product.id);
      if (cardCache[pid]) {
        grid.appendChild(cardCache[pid].cloneNode(true));
      } else {
        const card = buildCard(product);
        cardCache[pid] = card.cloneNode(true);
        grid.appendChild(card);
      }
    });

    // Fix images
    setTimeout(() => {
      grid.querySelectorAll('[data-injected="true"] img').forEach(img => {
        img.style.setProperty('opacity', '1', 'important');
        img.style.setProperty('visibility', 'visible', 'important');
        img.style.setProperty('display', 'block', 'important');
        if (img.naturalWidth === 0 && img.src) { const t = img.src; img.src = ''; img.src = t; }
      });
      isRendering = false;
      observer.observe(document.body, { childList: true, subtree: true });
    }, 100);

    // Hide original Boost pagination
    const boostPagination = document.querySelector('.boost-sd__pagination:not(#cpf-custom-pagination)');
    if (boostPagination) boostPagination.style.display = 'none';

    // Remove old custom pagination if any
    document.getElementById('cpf-custom-pagination')?.remove();

    // Count bar
    let countEl = document.getElementById('custom-price-count');
    if (!countEl) {
      countEl = document.createElement('div');
      countEl.id = 'custom-price-count';
      countEl.style.cssText = 'text-align:center;padding:8px;font-size:13px;color:#555;margin-bottom:10px;';
      grid.insertAdjacentElement('beforebegin', countEl);
    }
    const showing_from = start + 1;
    const showing_to = Math.min(start + ITEMS_PER_PAGE, products.length);
    countEl.textContent = `${showing_from}–${showing_to} von ${products.length} Produkten`;

    // Inject new custom pagination after grid
    if (totalPages > 1) {
      const paginationEl = buildCustomPagination(products.length, page);
      if (paginationEl) grid.insertAdjacentElement('afterend', paginationEl);
    }
  }

  // ─── Render filtered products (entry point after filter applied) ──────────
  function renderFilteredProducts(apiProducts) {
    const grid = document.querySelector('.boost-sd__product-list, .boost-sd__product-grid');
    if (!grid) return;

    if (!filterActive) originalGridHTML = grid.innerHTML;

    // Pre-cache existing DOM cards
    grid.querySelectorAll('.boost-sd__product-item[data-product-id]').forEach(card => {
      const pid = card.getAttribute('data-product-id');
      if (pid && !cardCache[pid]) cardCache[pid] = card.cloneNode(true);
    });

    // Apply price filter
    filteredProducts = apiProducts.filter(p => {
      const price = parseFloat(p.price_min) || 0;
      return price >= currentMin && price <= currentMax;
    });

    if (filteredProducts.length === 0) {
      isRendering = true;
      observer.disconnect();
      grid.innerHTML = '<p style="text-align:center;padding:40px;color:#999;grid-column:1/-1">Keine Produkte in diesem Preisbereich gefunden.</p>';
      document.getElementById('cpf-custom-pagination')?.remove();
      const boostPagination = document.querySelector('.boost-sd__pagination:not(#cpf-custom-pagination)');
      if (boostPagination) boostPagination.style.display = 'none';
      setTimeout(() => { isRendering = false; observer.observe(document.body, { childList: true, subtree: true }); }, 100);
    } else {
      currentFilterPage = 1;
      renderPage(filteredProducts, 1);
    }

    filterActive = true;
  }

  // ─── Reset ────────────────────────────────────────────────────────────────
  function resetToOriginal() {
    if (!filterActive) return;
    isRendering = true;
    observer.disconnect();
    const grid = document.querySelector('.boost-sd__product-list, .boost-sd__product-grid');
    if (grid && originalGridHTML !== null) grid.innerHTML = originalGridHTML;
    document.getElementById('cpf-custom-pagination')?.remove();
    document.getElementById('custom-price-count')?.remove();
    const pagination = document.querySelector('.boost-sd__pagination');
    if (pagination) pagination.style.display = '';
    filterActive = false;
    filteredProducts = [];
    allFetchedProducts = [];
    originalGridHTML = null;
    cardCache = {};
    currentFilterPage = 1;
    setTimeout(() => { isRendering = false; observer.observe(document.body, { childList: true, subtree: true }); }, 600);
  }

  // ─── FAST parallel fetch with chunked batching ────────────────────────────
  // Fires all requests at once using Promise.all.
  // Additionally: page 1 result is rendered immediately as preview
  // while remaining pages continue loading in background.
  async function fetchAllAndFilter() {
    if (isFetching) return;
    isFetching = true;

    // Cache existing visible cards before we touch the grid
    document.querySelectorAll('.boost-sd__product-item[data-product-id]').forEach(card => {
      const pid = card.getAttribute('data-product-id');
      if (pid) cardCache[pid] = card.cloneNode(true);
    });

    const totalPages = getTotalPages();
    showLoading(true, 'Produkte werden geladen...', 0, totalPages);

    let loadedCount = 0;

    // Fire ALL pages simultaneously — fastest possible approach
    const pagePromises = Array.from({ length: totalPages }, (_, i) => {
      return fetchBoostPage(i + 1).then(result => {
        loadedCount++;
        showLoading(true, 'Produkte werden geladen...', loadedCount, totalPages);
        return result;
      });
    });

    const results = await Promise.all(pagePromises);

    // Sort pages to maintain product order
    results.sort((a, b) => a.page - b.page);
    const allProducts = results.flatMap(r => r.products);

    allFetchedProducts = allProducts;

    // Pre-build card cache for all fetched products (faster rendering later)
    allFetchedProducts.forEach(product => {
      const pid = String(product.id);
      if (!cardCache[pid]) cardCache[pid] = buildCard(product);
    });

    console.log(`[PriceFilter] Fetched ${allFetchedProducts.length} products across ${totalPages} pages`);
    showLoading(false);
    renderFilteredProducts(allFetchedProducts);
    isFetching = false;
  }

  // ─── CSS ──────────────────────────────────────────────────────────────────
  function injectSliderCSS() {
    if (document.getElementById('custom-price-filter-css')) return;
    const s = document.createElement('style');
    s.id = 'custom-price-filter-css';
    s.textContent = `
      #custom-price-filter{padding:15px 0;border-bottom:1px solid #eee}
      #custom-price-filter h4{margin:0 0 14px;font-size:14px;font-weight:600;color:#222}
      .cpr-labels{display:flex;justify-content:space-between;font-size:13px;color:#333;margin-bottom:10px;font-weight:500}
      .cpr-slider-wrapper{position:relative;height:20px;margin-bottom:16px}
      .cpr-slider-rail{position:absolute;top:50%;transform:translateY(-50%);left:0;right:0;height:4px;background:#e0e0e0;border-radius:2px}
      #custom-range-track{position:absolute;top:0;height:100%;background:#222;border-radius:2px}
      .cpr-slider-wrapper input[type=range]{position:absolute;top:50%;transform:translateY(-50%);width:100%;-webkit-appearance:none;appearance:none;background:transparent;pointer-events:none;margin:0}
      .cpr-slider-wrapper input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;width:18px;height:18px;border-radius:50%;background:#fff;border:2px solid #222;cursor:pointer;pointer-events:all;box-shadow:0 1px 4px rgba(0,0,0,.15);transition:transform .1s}
      .cpr-slider-wrapper input[type=range]::-webkit-slider-thumb:hover{transform:scale(1.15)}
      .cpr-slider-wrapper input[type=range]::-moz-range-thumb{width:18px;height:18px;border-radius:50%;background:#fff;border:2px solid #222;cursor:pointer;pointer-events:all;box-shadow:0 1px 4px rgba(0,0,0,.15)}
      #custom-price-btn{width:100%;padding:9px;background:#000;color:#fff;border:none;border-radius:4px;cursor:pointer;font-size:13px;margin-bottom:6px;transition:background .2s}
      #custom-price-btn:hover{background:#333}
      #custom-price-reset{width:100%;padding:9px;background:#fff;color:#333;border:1px solid #ddd;border-radius:4px;cursor:pointer;font-size:13px}
      #custom-price-reset:hover{background:#f5f5f5}
      .boost-sd__product-item[data-injected="true"] img{opacity:1!important;visibility:visible!important;display:block!important}

      /* Custom pagination — matches Boost's own classes so it inherits theme styles */
      #cpf-custom-pagination{margin-top:24px;margin-bottom:16px}

      /* Loading overlay */
      #cpf-loading-overlay{
        position:fixed;inset:0;z-index:99999;
        background:rgba(0,0,0,0.5);
        display:flex;align-items:center;justify-content:center;
        backdrop-filter:blur(3px);
        opacity:0;transition:opacity 0.15s ease;
      }
      #cpf-loading-box{
        background:#fff;border-radius:14px;padding:36px 44px;
        text-align:center;min-width:300px;max-width:360px;
        box-shadow:0 12px 48px rgba(0,0,0,.22);
      }
      #cpf-spinner{
        width:48px;height:48px;margin:0 auto 18px;
        border:4px solid #e8e8e8;border-top-color:#111;
        border-radius:50%;animation:cpf-spin .65s linear infinite;
      }
      @keyframes cpf-spin{to{transform:rotate(360deg)}}
      #cpf-loading-text{font-size:15px;font-weight:600;color:#111;margin-bottom:16px;line-height:1.4}
      #cpf-loading-bar-wrap{background:#ebebeb;border-radius:8px;height:8px;overflow:hidden;margin-bottom:10px;}
      #cpf-loading-bar{height:100%;background:#111;border-radius:8px;width:0%;transition:width 0.25s ease;}
      #cpf-loading-sub{font-size:12px;color:#999;min-height:18px;letter-spacing:0.02em}
    `;
    document.head.appendChild(s);
  }

  function updateSliderTrack() {
    const minS = document.getElementById('custom-range-min'), maxS = document.getElementById('custom-range-max'),
          track = document.getElementById('custom-range-track'),
          minL = document.getElementById('custom-label-min'), maxL = document.getElementById('custom-label-max');
    if (!minS || !maxS || !track) return;
    const min = parseInt(minS.value), max = parseInt(maxS.value), gMin = parseInt(minS.min), gMax = parseInt(minS.max), range = gMax - gMin;
    track.style.left = ((min - gMin) / range * 100) + '%';
    track.style.right = ((gMax - max) / range * 100) + '%';
    if (minL) minL.textContent = 'CHF ' + min.toLocaleString('de-CH');
    if (maxL) maxL.textContent = 'CHF ' + max.toLocaleString('de-CH');
  }

  // ─── Insert UI ────────────────────────────────────────────────────────────
  function insertPriceFilter() {
    if (document.getElementById('custom-price-filter')) return;
    const katDiv = document.querySelector('[data-filteroptionid="pf_c_produktkategorie"]');
    if (!katDiv) return;

    injectSliderCSS();

    katDiv.insertAdjacentHTML('afterend', `
      <div id="custom-price-filter">
        <h4>Preis</h4>
        <div class="cpr-labels">
          <span id="custom-label-min">CHF ${globalMin.toLocaleString('de-CH')}</span>
          <span id="custom-label-max">CHF ${globalMax.toLocaleString('de-CH')}</span>
        </div>
        <div class="cpr-slider-wrapper">
          <div class="cpr-slider-rail"><div id="custom-range-track"></div></div>
          <input type="range" id="custom-range-min" min="${globalMin}" max="${globalMax}" step="50" value="${globalMin}">
          <input type="range" id="custom-range-max" min="${globalMin}" max="${globalMax}" step="50" value="${globalMax}">
        </div>
        <button type="button" id="custom-price-btn">Filter anwenden</button>
        <button type="button" id="custom-price-reset" style="display:none;">✕ Filter zurücksetzen</button>
      </div>
    `);

    const minS = document.getElementById('custom-range-min'), maxS = document.getElementById('custom-range-max');
    minS.addEventListener('input', function () {
      if (parseInt(this.value) > parseInt(maxS.value) - 50) this.value = parseInt(maxS.value) - 50;
      updateSliderTrack();
    });
    maxS.addEventListener('input', function () {
      if (parseInt(this.value) < parseInt(minS.value) + 50) this.value = parseInt(minS.value) + 50;
      updateSliderTrack();
    });
    updateSliderTrack();

    document.getElementById('custom-price-btn').addEventListener('click', async function () {
      currentMin = parseInt(minS.value);
      currentMax = parseInt(maxS.value);

      if (currentMin === globalMin && currentMax === globalMax) {
        resetToOriginal();
        document.getElementById('custom-price-reset').style.display = 'none';
        return;
      }

      document.getElementById('custom-price-reset').style.display = 'block';

      if (allFetchedProducts.length > 0) {
        // Already have data — just re-filter & render instantly, no loading screen
        renderFilteredProducts(allFetchedProducts);
      } else {
        showLoading(true, 'Filter wird vorbereitet...');
        waitForCapture(() => fetchAllAndFilter());
      }
    });

    document.getElementById('custom-price-reset').addEventListener('click', function () {
      minS.value = globalMin; maxS.value = globalMax;
      updateSliderTrack();
      currentMin = 0; currentMax = Infinity;
      resetToOriginal();
      this.style.display = 'none';
    });
  }

  // ─── Observer ─────────────────────────────────────────────────────────────
  let obsTimer;
  let isRendering = false;
  const observer = new MutationObserver(() => {
    if (isRendering) return;
    clearTimeout(obsTimer);
    obsTimer = setTimeout(() => {
      insertPriceFilter();
      if (filterActive && filteredProducts.length > 0) {
        const grid = document.querySelector('.boost-sd__product-list, .boost-sd__product-grid');
        if (grid && !document.getElementById('custom-price-count')) {
          renderPage(filteredProducts, currentFilterPage);
        }
      }
    }, 300);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  insertPriceFilter();
});